<script setup lang="ts">
import { ref } from 'vue';

/**
 * ローディングアニメーション
 * 親コンポーネントから ref 経由で show() / hide() を呼び出す想定。
 * 外部インターフェース（公開メソッド名）は変更しない。
 */

const isShow = ref<boolean>(false);

/**
 * ローディングを表示する
 */
const show = () => {
  isShow.value = true;
};

/**
 * ローディングを非表示にする
 */
const hide = () => {
  isShow.value = false;
};

defineExpose({
  show,
  hide
});
</script>

<template>
  <Teleport to="body">
    <div v-if="isShow">
      <div class='cvm_gray_panel'></div>
      <div class="loading">
        <img alt="" src="@/images/loading.gif">
      </div>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.cvm_gray_panel {
  background: #333;
  z-index: 100;
  opacity: 0.5;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.loading {
  margin: -50px 0px 0px -50px;
  padding: 20px;
  background: #fff;
  opacity: 0.8;
  border-radius: 4px;
  position: fixed;
  left: 50%;
  top: 50%;
  border: 1px solid #eee;
  z-index: 100;
}
</style>
